import Cookies from 'js-cookie';
import getRootDomain from 'utils/getRootDomain';

export type MetaIntegration = {
  fbp: string | null;
  fbc: string | null;
};

// _fbp/_fbc are set by the brand's Meta pixel on the brand's own domain; on
// brij.it-hosted pages they are deliberately nulled (same guard the original
// RegistrationDrawer inline block used - keep semantics identical).
const getMetaIntegration = (): MetaIntegration => {
  const isBrijHosted = getRootDomain(window.location.href)?.includes('brij.it');
  return {
    fbp: isBrijHosted ? null : (Cookies.get('_fbp') as string) || null,
    fbc: isBrijHosted ? null : (Cookies.get('_fbc') as string) || null,
  };
};

export default getMetaIntegration;
